// extracted by mini-css-extract-plugin
module.exports = {"header":"dropdown-header_header__WlhW0"};